// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
require("@rails/ujs").start();
require("@rails/activestorage").start();
require("jquery");
require("bootstrap");
// require("channels")

import "core-js/stable";
import "regenerator-runtime/runtime";
import { Turbo } from "@hotwired/turbo-rails";
import "bootstrap";
import "../stylesheets/application";
import "../stylesheets/calendar_auth_habit";
import "../stylesheets/calendar_auth";
import "../stylesheets/details";
import "../stylesheets/header";
import "../stylesheets/kaminari";
import "../stylesheets/layouts";
import "../stylesheets/line_auth";
import "../stylesheets/loading";
import "../stylesheets/media";
import "../stylesheets/notification";
import "../stylesheets/notion_integrations";
import "../stylesheets/records";
import "../stylesheets/reminders";
import "../stylesheets/style";
import "../stylesheets/tags";
import "../stylesheets/users";
import "../stylesheets/weathers";

Turbo.session.drive = false;

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
